import { EnvironmentFeatureFlagStateDto } from '@flagsync/skyline';
import { Row } from '@tanstack/react-table';
import * as React from 'react';
import { HTMLAttributes } from 'react';

import { VariantTargetingAudience } from '@/components/variant-targeting-audience';
import { cn } from '@/lib/utils';

export const AudienceTargetingCell = ({
  row,
}: {
  row: Row<EnvironmentFeatureFlagStateDto>;
}) => {
  const {
    isEnabled,

    isTargetedRollout,
    isPercentageRollout,
  } = row.original;

  return (
    <div className="flex flex-col gap-2">
      <VariantTargetingAudience
        isTargetedRollout={isTargetedRollout}
        isPercentageRollout={isPercentageRollout}
        isEnabled={isEnabled}
      />
    </div>
  );
};

export const AudienceTargetingCellBase = ({
  flag,
  className,
  containerClassName,
}: {
  flag: EnvironmentFeatureFlagStateDto;
  className?: string;
  containerClassName?: string;
}) => {
  const {
    isEnabled,
    isTargetedRollout,
    isPercentageRollout,
  } = flag;

  return (
    <div className={cn('flex flex-col gap-2', containerClassName)}>
      <VariantTargetingAudience
        className={className}
        isTargetedRollout={isTargetedRollout}
        isPercentageRollout={isPercentageRollout}
        isEnabled={isEnabled}
      />
    </div>
  );
};

export const AudienceTargetingMobileCell = ({
  flagState,
  className,
}: {
  flagState: EnvironmentFeatureFlagStateDto;
} & HTMLAttributes<HTMLDivElement>) => {
  const { isEnabled, isTargetedRollout, isPercentageRollout } = flagState;

  return (
    <div className={cn('flex flex-col gap-2', className)}>
      <VariantTargetingAudience
        isTargetedRollout={isTargetedRollout}
        isPercentageRollout={isPercentageRollout}
        isEnabled={isEnabled}
      />
    </div>
  );
};
